module.exports = __webpack_public_path__ + "img/idea_top.15fb45a1.png";